// ============================================
// APPLICATION - Tours Vistos Hooks
// ============================================
// Genérico: cualquier módulo con su propio tour de producto reusa estos
// mismos hooks contra el registro de "tours vistos" del usuario.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toursRepository } from '../../infrastructure/http/tours.repository';
import { queryKeys } from '../query-keys';

/** Tours ya vistos por el usuario autenticado actual, como "tourId:version". */
export const useToursVistos = () => {
  return useQuery({
    queryKey: queryKeys.tours.vistos(),
    queryFn: () => toursRepository.obtenerVistos(),
    staleTime: 5 * 60 * 1000,
  });
};

/** Marca un tour como visto — persiste en backend, sobrevive borrar localStorage. */
export const useMarcarTourVisto = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ tourId, version }: { tourId: string; version: string }) =>
      toursRepository.marcarVisto(tourId, version),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.tours.vistos() });
    },
  });
};
